query GetSunProtectionOrder($dealId: Long!) {
    getSunProtectionOrder(dealId: $dealId) {
        id
        dealId
        measurementFormSigned
        signature {
            id
            url
            type
            name
        }
        discountCode {
            id
            code
            percentage
        }
        products {
            id
            productId
            sunProtectionProductId
            productType
            colorId
            frameColorId
            controlType
        }
        createdAt
        updatedAt
    }
}
